import { useState } from "react";
import useDisplayUpdate from "../../hooks/useDisplayUpdate";
import { X, Loader2 } from "lucide-react";

export default function DisplayUpdateDialog({ onClose }) {
  const { displayUpdate, isLoading, error } = useDisplayUpdate();

  const [stationId, setStationId] = useState("");
  const [version, setVersion] = useState("");
  const [gunId, setGunId] = useState("");

  const handleSubmit = async () => {
    if (!stationId || !version || !gunId) {
      alert("All fields are required");
      return;
    }

    const res = await displayUpdate({ stationId, version, gunId });

    if (res.success) {
      alert("Display updated successfully");
      onClose();
    } else {
      alert("Error: " + res.error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-200">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Display App Update</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition"
          >
            <X size={18} className="text-gray-700" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Station ID
            </label>
            <input
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black/10"
              value={stationId}
              onChange={(e) => setStationId(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Version
            </label>
            <input
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black/10"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Gun ID
            </label>
            <input
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black/10"
              value={gunId}
              onChange={(e) => setGunId(e.target.value)}
            />
          </div>

          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>

          <button
            disabled={isLoading}
            onClick={handleSubmit}
            className="px-4 py-2 rounded-lg bg-black text-white flex items-center gap-2 hover:bg-gray-900 transition disabled:opacity-50"
          >
            {isLoading && <Loader2 size={16} className="animate-spin" />}
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
